import {makeAutoObservable} from "mobx";
import {ApiRolesService} from "../../../shared/api";

class RolesModel {
  roles = [];

  constructor() {
    makeAutoObservable(this);
  }

  setRoles(roles) {
    this.roles = roles
  }

  async fetch() {
    try {
      const {data} = await ApiRolesService.fetchRoles()
      this.setRoles(data)
    } catch (err) {
      console.log(err)
    }

  }
}

export const rolesModel = new RolesModel()


